import {createApp} from 'vue';
//import {createGtm} from '@gtm-support/vue-gtm';
import router from './router/router';
import App from './App';

const app = createApp(App);

app.use(router);

/*
// Hide google tag manager for now
app.use(
  createGtm({
    id: process.env.VUE_APP_GTM_ID,
    loadScript: true,
    vueRouter: router,
  })
);
*/

app.mount('#app');
